<template>
  <div id="app">
<router-view></router-view>
    </div>
</template>
<script lang="ts" setup>

</script>
<style lang="scss">
#app{
  width: 100%;
  height: 100%;
}
</style>